import { motion, useScroll, useSpring } from "framer-motion";

import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Experience } from "./components/Experience";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { BackToTop } from "./components/BackToTop";
import { useThemeMode } from "./hooks/useThemeMode";
import "./App.css";

function App() {
  const { mode, toggle } = useThemeMode();
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 26,
    mass: 0.2,
  });

  return (
    <>
      <a className="skip-link" href="#inicio">
        Pular para o conteúdo
      </a>

      <motion.div className="scroll-progress" style={{ scaleX: progress }} />

      <Nav mode={mode} onToggleTheme={toggle} />

      <main id="conteudo">
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Experience />
        <Projects />
        <Contact />
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}

export default App;
